import { EntitiesList } from '@/admin/billing/models/entities.enum';
import { CoreQuery } from '@/common/services/core-query';
import { httpClientCoreQuery } from '@/api/http-client';
import { DowngradeRestriction } from '@/admin/billing/models';
import { AxiosPromise } from 'axios';

import { PutSubscriptionRequest, SubscriptionPersonaApiFactory } from '@eloomi/eloomi-billing-persona-client/1.0';
import { authorizeClient } from '@/api/http-client';

const subscriptionClient = authorizeClient(SubscriptionPersonaApiFactory);

export function getCurrentPlanDetails() {
    return subscriptionClient.getActiveSubscription();
}

export async function deleteSubscription() {
    return subscriptionClient.deleteSubscription();
}

export async function putSubscription(payload: PutSubscriptionRequest) {
    return subscriptionClient.putSubscription(payload);
}

export function verifyLimits(size?): AxiosPromise<DowngradeRestriction[]> {
    const q = new CoreQuery().path([
        EntitiesList.BILLING,
        EntitiesList.PERSONA,
        EntitiesList.ACCOUNT,
        EntitiesList.SUBSCRIPTION,
        EntitiesList.VERIFY_LIMITS,
    ]);
    if (size) {
        q.param('size', size);
    }

    return httpClientCoreQuery.get(q);
}
